<p-toast></p-toast>

<div class="apps-container">
  <div *ngFor="let app of apps" class="app-card" (click)="navigateTo(app.url)">
    <i [ngClass]="app.icon" class="app-icon"></i>
    <h3>{{ app.title }}</h3>
    <p>{{ app.description }}</p>
  </div>
</div>